import react, {useEffect, useState, useRef} from "react"
import useToken, { useTerritory, useTenancy, useUser} from './useToken';
import { BarChart, Bar, Cell, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';


export default function Analytics(){
    const token = useToken();
    //const user = useUser();
    const user =21;

    
 
    const[loading, setLoading] = useState(false);
    const[chartData, setChartData] = useState([]);
    
    
    useEffect(()=>{

        setLoading(true);


        const URLForAnalytics =process.env.NODE_ENV === 'development' ? `${process.env.REACT_APP_API_URL_DEV_MODE}api/analytics/${user}/`: `${process.env.REACT_APP_API_URL_PROD_MODE}api/analytics/${user}/`;
       
        fetch(URLForAnalytics, { headers: {"Authorization" :  `Token ${token}`}})
        
        .then((res) => res.json())
        .catch(error=> console.log(error))
        .then((data)=>{

            setChartData(data);
            /*

            let labelXAxis=[]
            let dataYAxis=[]
           
            if (data && !data.error){
                data.map((item)=>{
                    labelXAxis = [...labelXAxis, item.flow_phase_name]
                    dataYAxis = [...dataYAxis, item.prospectcount]
                })
                
            }
            
            */
            
            

        })
        .catch(error=> console.log(error))
        .finally(()=>{
            setLoading(false)
        })
        
    }, []);

    if (loading)
        return <>Loading..</>

    return (<>
                
            <BarChart width={730} height={500} data={chartData}  margin={{ top: 100, right: 20, left: 100, bottom: 5 }}>
                <CartesianGrid strokeDasharray="4 4" />
                <XAxis dataKey="flow_phase_name" />
                <YAxis dataKey="prospectcount" />
                <Tooltip />
                <Legend />
                <Bar dataKey="flow_phase_name" fill="#8884d8" />
                <Bar dataKey="prospectcount" fill="#82ca9d" />
               
            </BarChart>
      
            </>);


}
